'use client'

import cn from 'clsx'
import { useState, useEffect } from 'react'
import Link from 'next/link'
import styles from './footer.module.scss'
import s from '../footer/footer.module.scss'

interface FooterProps {
  className?: string
}

const Footer: React.FC<FooterProps> = ({ className }) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY
      const windowHeight = window.innerHeight
      const documentHeight = document.documentElement.scrollHeight

      // Show footer effect when near bottom of page
      const threshold = documentHeight - windowHeight * 1.5
      setIsVisible(scrollPosition > threshold)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <>
      <footer
        className={`${styles.footer} ${isVisible ? styles.visible : ''} ${
          className || ''
        }`}
        id="footer"
      >
        <div className={styles.backdrop}></div>

        <div className={styles.container}>
          {/* Main Column */}
          <div className={`${styles.col} ${styles.col1}`}>
            <h3 style={{fontStretch: 'expanded'}}>XENO</h3>
            <div className={styles.social}>
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
              >
                <img
                  src="/social-media-icons/telegram.png"
                  alt="Telegram"
                />
              </a>
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
              >
                <img
                  src="/social-media-icons/twitter.png"
                  alt="Twitter"
                />
              </a>
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
              >
                <img
                  src="/social-media-icons/linkedin.png"
                  alt="LinkedIn"
                />
              </a>
            </div>
            <div className={styles.social}>
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
              >
                <img
                  src="/social-media-icons/gitbook.png"
                  alt="Gitbook"
                />
              </a>
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
              >
                <img
                  src="/social-media-icons/medium.png"
                  alt="Medium"
                />
              </a>
              <a
                href="#"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.socialLink}
              >
                <img
                  src="/social-media-icons/linktree.png"
                  alt="Linktree"
                />
              </a>
            </div>
            <p style={{ color: '#b8b8b8ff', fontSize: 'smaller', width: '200px'}}>
              2025 © All Rights Reserved.
            </p>
          </div>

          {/* Navigation Column */}
          <div className={`${styles.col} ${styles.col2}`}>
            <Link href="/" className={styles.link}>
              Home
            </Link>
            <Link href="/ecosystem" className={styles.link}>
              Ecosystem
            </Link>
            <Link href="/token" className={styles.link}>
              Token
            </Link>
            <Link href="/roadmap" className={styles.link}>
              Roadmap
            </Link>
          </div>

          {/* Services Column */}
          <div className={`${styles.col} ${styles.col3}`}>
            <Link href="/team" className={styles.link}>
              Team
            </Link>
            <Link href="/contact" className={styles.link}>
              Contact Us
            </Link>
            <Link href="/privacyPolicy" className={styles.link}>
              Privacy Policy
            </Link>
            <Link href="/terms" className={styles.link}>
              Terms
            </Link>
          </div>
        </div>

        <div
          className={cn(s.top, styles.footpara, 'hide-on-mobile')}
          style={{ paddingLeft: '15px'}}
        >
          <p className={cn(s['first-line'], 'h4')}>
            Whether you're a builder, a buyer, or an investor — XENO invites you
            to become part of a{' '}
            <span className="contrast">global movement</span>. We're deploying
            out of Dubai, scaling globally, and building the future block by
            block, bot by bot. &nbsp;
          </p>
        </div>
        <div className={cn(s.top, 'layout-block hide-on-desktop hide-on-tablet')}>
          <p className={cn(s['first-line'], 'h4', 'text-white')}>
            Whether you're a builder, a buyer, or an investor — XENO invites you
            to become part of a{' '}
            <span className="contrast">global movement</span>. We're deploying
            out of Dubai, scaling globally, and building the future block by
            block, bot by bot.&nbsp;
          </p>
        </div>
      </footer>

      {/* CSS Styles */}
      <style jsx>{`
        .hide-on-tablet {
          display: block;
        }
        
        @media screen and (min-width: 500px) and (max-width: 1000px) {
          .hide-on-tablet {
            display: none !important;
          }
        }
      `}</style>
    </>
  )
}

export default Footer